import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/Common";

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const [f, setF] = useState({ current_password: "", new_password: "" });
  const save = async () => {
    try {
      await api.post("/auth/change-password", f);
      toast.success("Password aggiornata");
      setF({ current_password: "", new_password: "" });
      onOpenChange(false);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader><DialogTitle>Cambia password</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <Field label="Password attuale">
            <Input type="password" data-testid="current-password-input" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} />
          </Field>
          <Field label="Nuova password (min. 8 caratteri)">
            <Input type="password" data-testid="new-password-input" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} />
          </Field>
        </div>
        <DialogFooter><Button data-testid="save-password-button" onClick={save}>Salva</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
